var viewer_caption_rtlignore_default = {
  "fontElementMap": "-ivQY",
  "imageCaption": "C0xLw"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
